import { hasEnabled, } from '@debbie/common/dist/feature-flags/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import { useMe } from '@debbie/cortex/dist/me/index.js';
import { useTenant } from '@debbie/cortex/dist/tenant/index.js';
export const useVariation = (flag, loadingValue = false) => {
    const tenant = useTenant();
    const meLoadable = useMe();
    const me = h.hasData(meLoadable) ? meLoadable.data : null;
    if (!tenant || !me) {
        return loadingValue;
    }
    // TODO(fq): add feature flags to user as well
    return hasEnabled(flag, tenant);
};
//# sourceMappingURL=index.js.map